// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".peer-calling{width:100%;height:100%;background:#b0666694;z-index:9999;position:absolute;left:0;top:0;display:flex;justify-content:center;align-items:center;flex-direction:column;gap:16px}.peer-calling h3{padding:10px 16px;border-radius:18px;font-size:2em;background:transparent;color:#000}.peer-calling a{max-width:200px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
